import { useCallback } from "react";
import { useLocale } from "@/locale/LocaleProvider";
import { localizedPath } from "@/locale/routes";

/** Возвращает путь с префиксом `/ru` для текущего языка интерфейса. */
export function useLocalizedPath() {
  const { lang } = useLocale();
  return useCallback((basePath: string) => localizedPath(basePath, lang), [lang]);
}
